import { useCallback, useState } from 'react';

export function useDismissableBanner(key, expiresIn) {
  const [hidden, setHidden] = useState(() => getLocalStorageBannerHidden(key));

  const hideBanner = useCallback(() => {
    setHidden(true);
    setLocalStorageBannerHidden(key, expiresIn);
  }, [key, expiresIn]);

  return [hidden, hideBanner];
}

let cachedBannerState = null;
export function getLocalStorageBannerHidden(key) {
  if (!key) return false;
  const allBannerState = (cachedBannerState ||= safeParseLocalStorageJSON('wz_banner_state') || {});
  const bannerState = allBannerState[key];
  return bannerState && (bannerState.exp < 0 || bannerState.exp > Date.now());
}

export function setLocalStorageBannerHidden(key, expiresIn) {
  if (!key) return;
  try {
    const now = Date.now();
    cachedBannerState = { ...cachedBannerState, [key]: { exp: expiresIn >= 0 ? now + expiresIn : -1 } };
    Object.entries(cachedBannerState).forEach(([key, value]) => {
      if (value.exp < now && value.exp >= 0) delete cachedBannerState[key];
    });
    window.localStorage?.setItem('wz_banner_state', JSON.stringify(cachedBannerState));
  } catch (ignoreError) {
    /* ignore error */
  }
}

function safeParseLocalStorageJSON(key) {
  try {
    return JSON.parse(window.localStorage?.getItem(key) || '{}');
  } catch (ignoreError) {
    // ignore error
  }
}
